var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('carousel',[_c('div',{attrs:{"slot":"title"},slot:"title"},[_vm._v("Page not found.")]),_c('div',{attrs:{"slot":"text"},slot:"text"},[_vm._v("Sorry the page you're looking does not exist.")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }